const GENERIC_DISPLAY_NAMES = new Set(["super admin", "super_admin", "administrator", "admin"]);

function usablePersonName(value, loginId = "") {
  const name = String(value || "").trim();
  if (!name || name === loginId) return "";
  if (GENERIC_DISPLAY_NAMES.has(name.toLowerCase())) return "";
  return name;
}

export function adminDisplayName(user) {
  if (!user) return "관리자";
  const loginId = String(user.login_id || "").trim();
  const display = usablePersonName(user.display_name, loginId);
  if (display) return display;
  const name = usablePersonName(user.name, loginId);
  if (name) return name;
  if (user.sales_level === "sales_super_admin") return "영업총괄";
  if (user.sales_level === "team_leader") return "팀장";
  if (user.sales_level === "member") return "직원";
  if (user.role === "super_admin") return "최고관리자";
  return "관리자";
}

export const ROLE_LABEL = {
  super_admin: "DEV-관리자",
  sub_admin: "부관리자",
};

export const SALES_LEVEL_LABEL = {
  sales_super_admin: "MKT-관리자",
  team_leader: "팀장",
  member: "직원",
};

export function adminRoleLabel(user) {
  if (!user) return "-";
  if (user.role === "super_admin") return ROLE_LABEL.super_admin;
  if (user.department === "sales") return SALES_LEVEL_LABEL[user.sales_level] || "영업팀";
  return ROLE_LABEL[user.role] || "관리자";
}
